// Environment specific variables. Copy this file to env.js and edit the specific variables. 
// For example the subdomain for the dev server should be onpointdev and for the prod - onpoint. 
// The file /src/config/env.js is not tracked by git and will remain local on the server. 

export default {
  base_url: "https://onpoint.oria.ch",
  graphqluri: "https://onpoint.oria.ch/graphql",
  login_url: "https://onpoint.oria.ch/api/users/login-ldap",
  me_url: "https://onpoint.oria.ch/api/user/me",
  redirectUri: "https://onpoint.oria.ch/auth/success",
  login_openid_url: "https://onpoint.oria.ch/api/users/login-openid"
};